import {NgModule} from '@angular/core';
import {AddSubstituteComponent} from './modals/add-substitute/add-substitute.component';
import {SubstitesComponent} from './pages/substites/substitutes.component';
import {SubstituteDepsModule} from './substitute-deps.module';
import {SubstituteRoutingModule} from './substitute-routing.module';
import {EditSubstituteFormComponent} from './common/edit-substitute-form/edit-substitute-form.component';
import {EditSubstituteComponent} from './modals/edit-substitute/edit-substitute.component';
import {SubstituteListComponent} from './common/substitute-list/substitute-list.component';


@NgModule({
    declarations: [
        SubstitesComponent,
        EditSubstituteFormComponent,
        EditSubstituteComponent,
        AddSubstituteComponent,
        SubstituteListComponent
    ],
    imports: [
        SubstituteRoutingModule,
        SubstituteDepsModule,
    ]
})
export class SubstituteModule { }
